<script>
import MyEdu from "@/components/myedu/MyEdu";
export default MyEdu
</script>